import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import Time from "../../Time/Time";
import ContractFactory from "../../Entity/Factories/ContractFactory";
import ChargeTemplateFactory from "../../Entity/Factories/ChargeTemplateFactory";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ContractInterface } from "../../Entity/Entities/Contract/ContractInterface";
import { ChargeTemplateInterface } from "../../Entity/Entities/Charge/ChargeTemplateInterface";
import { MainTenant } from "../../Entity/Entities/ContactForContract/Type/Types/MainTenant";
import Translator from "../../Translation/Translator";
// import { AgencyFeeInterface } from "../../Entity/Entities/AgencyFee/AgencyFeeInterface";
// import AgencyFeeFactory from "../../Entity/Factories/AgencyFeeFactory";

export default function* contractCreate(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_CONTRACT_CREATE_ERRORS_CLEAR
    });

    yield put({
      type: Constants.GLOBAL_CONTRACT_CREATE_REQUEST
    });

    const contactForContracts: any[] = [];

    // First, we have to push Tenant into the array of Persons.
    if (!!action.payload?.selectedPerson) {
        contactForContracts.push({
        contactId: action.payload?.сreatedFromCoach ? null : action.payload?.selectedPerson?.id || null,
        contractPartyDescription: "Tenant",
        contactForContractTypeId: MainTenant.contactForContractTypeId
      });
    }
    
    // If we have additional fields, we have to push those into the array too.
    action.payload?.additionalFields?.forEach(field => {
      if (!field) {
        return;
      }

      if (typeof field?.selectedPerson === "undefined") {
        return;
      }

      contactForContracts.push({
        contactId: field.selectedPerson && field?.selectedPerson?.id,
        contractPartyDescription: field.description,
        contactForContractTypeId: field.contactForContractTypeId
      });
    });

    let chargeTemplates;
    
    if(action.payload?.сreatedOnFrontend){
      chargeTemplates = action.payload?.chargeTemplates?.map((chargeTemplate: ChargeTemplateInterface) => {
        return {
          amount: chargeTemplate?.amount,
          currencyId: chargeTemplate?.currency,
          type: chargeTemplate?.type,
          repeatPeriodId: chargeTemplate?.repeatPeriod,
          description: chargeTemplate?.description,
          paymentOffset: chargeTemplate?.paymentOffset,
          dueDateFirstPayment: Time.formatOrNull(chargeTemplate?.dueDateFirstPayment),
          firstDate: Time.formatOrNull(chargeTemplate?.firstDate),
          endDate: Time.formatOrNull(chargeTemplate?.endDate),
          isPaidDirectlyToOwner: chargeTemplate?.isPaidDirectlyToOwner,
          contactId: chargeTemplate.contactId,
          companyId: chargeTemplate.companyId,
          isCollective: chargeTemplate?.isCollective
        };
      })
    } else {
      action.payload?.chargeTemplates?.map((chargeTemplate: ChargeTemplateInterface) => {
        return {
          id: chargeTemplate.id,
          amount: chargeTemplate.amount,
          currency: chargeTemplate.currency.getCurrencyId(),
          type: chargeTemplate.type.id,
          repeatPeriod: chargeTemplate?.repeatPeriod?.id,
          description: chargeTemplate.description,
          paymentOffset: chargeTemplate.paymentOffset?.getValue(),
          dueDateFirstPayment: Time.formatOrNull(chargeTemplate.dueDateFirstPayment),
          firstDate: Time.formatOrNull(chargeTemplate.firstDate),
          endDate: Time.formatOrNull(chargeTemplate.endDate),
          isPaidDirectlyToOwner: chargeTemplate.isPaidDirectlyToOwner,
          contactId: chargeTemplate.contactId,
          companyId: chargeTemplate.companyId,
          isCollective: chargeTemplate?.isCollective
        };
      })
    }

    const res = yield call(Http.post, `contract`, {
      unitId: action.payload?.unit && action.payload?.unit.id,
      amazonFolderName: action.payload?.amazonFolderName,
      contractStatusId: action.payload?.status,
      note: action.payload?.note,
      checkinDate: null,
      checkoutDate: null,
      contactForContracts: contactForContracts,
      mainTenantContactId: action.payload?.selectedPerson?.id,
      mainTenantCompanyId: action.payload?.selectedCompany?.id,
      firstDate: Time.formatOrNull(action.payload?.firstDate),
      lastDate: Time.formatOrNull(action.payload?.lastDate),
      endDate: Time.formatOrNull(action.payload?.endDate),
      expirationDate: Time.formatOrNull(action.payload?.expirationDate),
      finalRentalPeriodDate: Time.formatOrNull(action.payload?.finalRentalPeriodDate),
      chargeTemplates: chargeTemplates,
      amazonFoldernameTenant: action.payload?.сreatedFromCoach ? action.payload?.amazonFoldernameTenant : undefined,
      mainContactFirstName: action.payload?.сreatedFromCoach ? action.payload?.mainContactFirstName: undefined,
      mainContactLastName: action.payload?.сreatedFromCoach ? action.payload?.mainContactLastName: undefined,
      autoSendInvoiceToTenant: action.payload?.autoSendInvoiceToTenant,
      isCommercial: action.payload?.isCommercial,
      // agencyFee: !!action.payload?.agencyFee ? {
      //   fixedFee: action.payload?.agencyFee.fixedFee,
      //   percentageFee: action.payload?.agencyFee.percentageFee,
      //   currency: action.payload?.agencyFee.currency.getCurrencyId(),
      //   fixedPlusPercentageMode: action.payload?.agencyFee.fixedPlusPercentageMode.id
      // } : null
    });

    yield res.data.chargeTemplates.map(rawChargeTemplate => {
      const chargeTemplate: ChargeTemplateInterface = ChargeTemplateFactory.create(rawChargeTemplate);

      return put({
        type: Constants.GLOBAL_CHARGE_TEMPLATE_UPDATE_SUCCESS,
        payload: {
          chargeTemplate: chargeTemplate
        }
      });
    });

    // if (res.data.agencyFee) {
    //   const agencyFee: AgencyFeeInterface = AgencyFeeFactory.create(res.data.agencyFee);

    //   yield put({
    //     type: Constants.GLOBAL_AGENCY_FEE_CREATE_SUCCESS,
    //     payload: {
    //       agencyFee: agencyFee
    //     }
    //   });
    // }

    const contract: ContractInterface = ContractFactory.create(res.data);

    yield put({
      type: Constants.GLOBAL_CONTRACT_CREATE_SUCCESS,
      payload: {
        contract: contract
      }
    });

    if (!action.payload?.hideSnackbar) { 
      yield put({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: Translator.trans("snackbar-message-contract-created-successfully"),
          type: "success"
        }
      });
    }

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, contract);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_CONTRACT_CREATE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchContractCreate() {
  yield takeEvery(Constants.GLOBAL_CONTRACT_CREATE_START, contractCreate);
}
